/*
 *  Copyright (c) 2018-present, Evgeny Nadymov
 *
 * This source code is licensed under the GPL v.3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import createSvgIcon from '@material-ui/core/esm/utils/createSvgIcon';

export default createSvgIcon(
    <path
        d='M5,14 C5.55228475,14 6,14.4477153 6,15 L6,18 L9,18 C9.55228475,18 10,18.4477153 10,19 C10,19.5522847 9.55228475,20 9,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,15 C4,14.4477153 4.44771525,14 5,14 Z M19,14 C19.5522847,14 20,14.4477153 20,15 L20,15 L20,19 C20,19.5522847 19.5522847,20 19,20 L19,20 L15,20 C14.4477153,20 14,19.5522847 14,19 C14,18.4477153 14.4477153,18 15,18 L15,18 L18,18 L18,15 C18,14.4477153 18.4477153,14 19,14 Z M9,4 C9.55228475,4 10,4.44771525 10,5 C10,5.55228475 9.55228475,6 9,6 L9,6 L6,6 L6,9 C6,9.55228475 5.55228475,10 5,10 C4.44771525,10 4,9.55228475 4,9 L4,9 L4,5 C4,4.44771525 4.44771525,4 5,4 L5,4 Z M19,4 C19.5522847,4 20,4.44771525 20,5 L20,9 C20,9.55228475 19.5522847,10 19,10 C18.4477153,10 18,9.55228475 18,9 L18,6 L15,6 C14.4477153,6 14,5.55228475 14,5 C14,4.44771525 14.4477153,4 15,4 L19,4 Z'
    />,
    'FullScreen'
);